import moment from 'moment-timezone'

/** Даты CRM с бэка без Z/offset — UTC «наивно», показ в МСК (как канбан / карточка лида). */
const CRM_MSK = 'Europe/Moscow'
const CRM_NAIVE_MYSQL = 'YYYY-MM-DD HH:mm:ss'

const hasExplicitTimezone = (value: string) => {
  const t = value.trim()
  return /[zZ]\d*(\.\d+)?$/.test(t) || /[+-]\d{2}:?\d{2}$/.test(t)
}

const toMskMoment = (date: string | number, unix?: boolean) => {
  if (unix) return moment.unix(Number(date)).tz(CRM_MSK)
  const s = String(date).trim()
  if (!s) return moment.invalid()
  if (hasExplicitTimezone(s)) return moment(s).tz(CRM_MSK)
  const strictUtc = moment.utc(s, [
    moment.ISO_8601,
    CRM_NAIVE_MYSQL,
    'YYYY-MM-DDTHH:mm:ss.SSSSSS',
    'YYYY-MM-DDTHH:mm:ss',
  ], true)
  if (strictUtc.isValid()) return strictUtc.tz(CRM_MSK)
  const looseUtc = moment.utc(s)
  return looseUtc.isValid() ? looseUtc.tz(CRM_MSK) : moment.invalid()
}

/** Дата+время для полей лида / истории статусов (UTC с API → МСК). */
export const formatCrmDateTimeMsk = (date: string | number, unix?: boolean) => {
  const m = toMskMoment(date, unix)
  return m.isValid() ? m.format('DD.MM.YY HH:mm') : String(date)
}

export const formatCrmDateMsk = (date: string | number, unix?: boolean) => {
  const m = toMskMoment(date, unix)
  return m.isValid() ? m.format('DD.MM.YY') : String(date)
}

/** Дата для бейджей канбана: `dd.mm.yyyy`. */
export const formatCrmKanbanBadgeDate = (date: string | number, unix?: boolean) => {
  const m = toMskMoment(date, unix)
  return m.isValid() ? m.format('DD.MM.YYYY') : String(date)
}

/** Дата и время для бейджей канбана: `dd.mm.yyyy HH:mm`. */
export const formatCrmKanbanBadgeDateTime = (
  date: string | number,
  unix?: boolean,
) => {
  const m = toMskMoment(date, unix)
  return m.isValid() ? m.format('DD.MM.YYYY HH:mm') : String(date)
}

export const formatCrmTimeMsk = (date: string | number, unix?: boolean) => {
  const m = toMskMoment(date, unix)
  return m.isValid() ? m.format('HH:mm') : String(date)
}

export const formatDateTime = (date: string | number, unix?: boolean) =>
  unix
    ? moment.unix(Number(date)).format('DD.MM.YY HH:mm')
    : moment(date).format('DD.MM.YY HH:mm')

export const formatDate = (date: string | number, unix?: boolean) =>
  unix
    ? moment.unix(Number(date)).format('DD.MM.YY')
    : moment(date).format('DD.MM.YY')

export const formatTime = (date: string | number, unix?: boolean) =>
  unix
    ? moment.unix(Number(date)).format('HH:mm')
    : moment(date).format('HH:mm')

export const formatCallDuration = (seconds: number) => {
  const duration = moment.duration(seconds, 'seconds')

  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  const secs = duration.seconds()

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs
      .toString()
      .padStart(2, '0')}`
  }

  if (minutes > 0) {
    return `${minutes}:${secs.toString().padStart(2, '0')}`
  }

  return `0:${secs}`
}
